import React from 'react';
import styled from 'styled-components';
import { dateTranslate, styles } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';

const StyledMenu = styled.div`
    background-color: white;
    width: ${(props) => props.$width}px;
    height: 100%;
    border-right: 1px solid ${styles.theme.border.alto};
    overflow: auto;
    flex-shrink: 0;
`;
const StyledHeader = styled.div`
    position: sticky;
    top: 0;
    background-color: white;
    height: 40px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: 14px;
    padding: 0 10px;
    font-weight: 700;
    color: ${styles.theme.fontColors.doveGray};
    border-bottom: 1px solid ${styles.theme.border.alto};
`;
const StyledDaySummary = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    padding: 10px;
    border-bottom: 1px solid ${styles.theme.border.alto};
    width: 100%;
    text-align: left;
    background-color: ${(props) => (props.$isSelected ? '#E6F5FF' : 'white')}
`;
const StyledDaySummaryTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${styles.theme.fontColors.darkBlue};
`;
const StyledDaySummarySubtitle = styled.div`
    font-weight: 700;
    font-size: 14px;
    color: ${styles.theme.fontColors.doveGray};
`;
const StyledSummaryData = styled.div`
    font-size: 13px;
    margin-top: 2px;
`;
const StyledMenuItem = styled.div`
    margin-top: 2px;
`;
export const MenuItemKey = styled(StyledMenuItem)`
    font-weight: bold;
`;
export const MenuItemValue = styled(StyledMenuItem)`
    color: ${styles.theme.fontColors.mineShaft}
`;

const getOpponent = (translate, ds) => {
    if (!ds.gameid) { return ''; }

    return ds.teamid === ds.hometeamid ? `${translate('baseball.abbr-versus')} ${ds.awayabbr}` : `@ ${ds.homeabbr}`;
};

const Menu = ({ daySummaries, selectedDaySummaryId, setSelectedDaySummaryId, menuItemComponent: MenuItem, width = 250 }) => {
    const { t: translate } = useTranslation();

    return (
        <StyledMenu $width={width}>
            <StyledHeader>
                {translate('sections.mechanics-workload.workload-mechanics')}
            </StyledHeader>
            {daySummaries.map((ds) => (
                <StyledDaySummary
                    key={ds.daysummaryid}
                    $isSelected={selectedDaySummaryId === ds.daysummaryid}
                    onClick={() => setSelectedDaySummaryId(ds.daysummaryid)}
                >
                    <div className="d-flex justify-content-between">
                        <StyledDaySummaryTitle>
                            {dateTranslate(translate, ds.date)}
                        </StyledDaySummaryTitle>
                        <StyledDaySummarySubtitle>
                            {getOpponent(translate, ds)}
                        </StyledDaySummarySubtitle>
                    </div>
                    <StyledSummaryData>
                        <MenuItem daySummary={ds} />
                    </StyledSummaryData>
                </StyledDaySummary>
            ))}
        </StyledMenu>
    );
};

export default Menu;
